module.exports = __webpack_public_path__ + "static/img/certificate-bg.e56d8be7.jpg";